"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayStatsResponseToJSON = exports.PlayStatsResponseFromJSONTyped = exports.PlayStatsResponseFromJSON = void 0;
var runtime_1 = require("../runtime");
function PlayStatsResponseFromJSON(json) {
    return PlayStatsResponseFromJSONTyped(json, false);
}
exports.PlayStatsResponseFromJSON = PlayStatsResponseFromJSON;
function PlayStatsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'xpOverall': !(0, runtime_1.exists)(json, 'xpOverall') ? undefined : json['xpOverall'],
        'xpGaming': !(0, runtime_1.exists)(json, 'xpGaming') ? undefined : json['xpGaming'],
        'xpOther': !(0, runtime_1.exists)(json, 'xpOther') ? undefined : json['xpOther'],
        'timePlayed': !(0, runtime_1.exists)(json, 'timePlayed') ? undefined : json['timePlayed'],
        'gamesPlayed': !(0, runtime_1.exists)(json, 'gamesPlayed') ? undefined : json['gamesPlayed'],
        'timeFilter': !(0, runtime_1.exists)(json, 'timeFilter') ? undefined : json['timeFilter'],
        'startDate': !(0, runtime_1.exists)(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'endDate': !(0, runtime_1.exists)(json, 'endDate') ? undefined : (new Date(json['endDate'])),
    };
}
exports.PlayStatsResponseFromJSONTyped = PlayStatsResponseFromJSONTyped;
function PlayStatsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'xpOverall': value.xpOverall,
        'xpGaming': value.xpGaming,
        'xpOther': value.xpOther,
        'timePlayed': value.timePlayed,
        'gamesPlayed': value.gamesPlayed,
        'timeFilter': value.timeFilter,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
    };
}
exports.PlayStatsResponseToJSON = PlayStatsResponseToJSON;
